import axios from 'axios'
import app from '../main.js'
// import store from '../store'
console.log(app)
let token = window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''

const service = axios.create({
  baseURL: process.env.BASE_URI,
  timeout: 60 * 1000, // 请求超时时间,
  headers: {
    "Content-Type": "application/json",
    "X-Access-Token": token,
    "clientType": 'PC'
  },
  // withCredentials: true,
  // crossDomain: true,
});


service.interceptors.response.use(

  response => {
    if (response.data.code === 200 || response.data.code === 0) {
      return Promise.resolve(response);
    } else {
      switch (response.data.code) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          app.$message.error('登录过期，请重新登录')
          window.localStorage.clear()
          app.$router.push('/login')
          // notification.error({
          //     message: "请求失败",
          //     description: "登录过期，请重新登录"
          // });
          // axios.get('/relog').then(() => {
          //     location.href = window.location.origin
          // })
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          app.$message.error('登录过期，请重新登录')
          // notification.error({
          //     message: "请求失败",
          //     description: "登录过期，请重新登录"
          // });
          break;
        // 404请求不存在
        case 404:
          app.$message.error('网络请求不存在')
          // notification.error({
          //     message: "请求失败",
          //     description: "网络请求不存在"
          // });
          break;
        // 其他错误，直接抛出错误提示
        default:
          app.$message.error(response.data.message)
        // notification.error({
        //     message: "请求失败",
        //     description: error.response.data.message
        // });
      }
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log(error)
    if (error.response.data.code) {
      switch (error.response.data.code) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          app.$message.error('登录过期，请重新登录')
          // notification.error({
          //     message: "请求失败",
          //     description: "登录过期，请重新登录"
          // });
          // axios.get('/relog').then(() => {
          //     location.href = window.location.origin
          // })
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          app.$message.error('登录过期，请重新登录')
          // notification.error({
          //     message: "请求失败",
          //     description: "登录过期，请重新登录"
          // });
          break;
        // 404请求不存在
        case 404:
          app.$message.error('网络请求不存在')
          // notification.error({
          //     message: "请求失败",
          //     description: "网络请求不存在"
          // });
          break;
        // 其他错误，直接抛出错误提示
        default:
          app.$message.error(error.response.data.message)
        // notification.error({
        //     message: "请求失败",
        //     description: error.response.data.message
        // });
      }
      return Promise.reject(error.response);
    }
  }
);
export default service



// WEBPACK FOOTER //
// ./src/api/request.js